// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.RedDotDate {
        font-weight: bold;
}
.RedDotDate::after {
        content: '';
        display: block;
        width: 3px; /* Size of the dot */
        height: 3px; /* Size of the dot */
        background-color: red;
        border-radius: 50%; /* Makes it round */
        position: absolute;
        bottom: 5px; /* Adjusts vertical position */
        left: 50%; /* Centers the dot horizontally */
        transform: translateX(-50%); /* Ensures it is centered */
}
.dots-fill {
        overflow: hidden;
        white-space: nowrap;
}
.dots-fill .dots-after:after {
            content: " ....................................................................................................................................................................";
}
.highlight-hover:hover {
        background-color: #e4ffd9
}
.flip-enter-active {
        transition: all 0.4s ease;
}
.flip-leave-active {
        display: none;
}
.flip-enter, .flip-leave {
        transform: rotateY(180deg);
        opacity: 0;
}
.light-info {
        color: rgba(10, 191, 83, 0.5) !important;
}
.numberCircle {
        position: relative;
        top: -8px;
        border-radius: 50%;
        width: 36px;
        height: 36px;
        padding: 4px;
        padding-top: 8px;
        background: rgba(10, 191, 83, 0.5);
        border: 2px solid limegreen;
        color: white;
        text-align: center;
        font: 14px Arial, sans-serif;
}
.checkout-content {
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        position: relative;
        z-index: 1;
}
.checkout-content::before {
            content: "";
            display: block;
            position: absolute;
            z-index: -1;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            background: rgba(255,255,255,.8);
}

        /* Style the content inside .contact-checkout-content */
.checkout-content .row {
            color: #fff;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
